import {
  AllegroDeliveryMethods,
  AllegroDeliveryServices,
  AllegroOrderCarriers,
  AllegroShippingRateDetail,
  AllegroShippingRates,
} from '../allegroApiTypes';

export const mockGetAllegroShippingRates: AllegroShippingRates = {
  shippingRates: [
    {
      id: '7470ffe8-8691-4c35-9f2b-a8e527b523bc',
      name: 'Ceska Posta',
    },
    {
      id: 'ae92d50c-5dfb-44b3-abe6-283d386c2542',
      name: 'DPD',
    },
    {
      id: 'a941cfdc-f4f7-4557-8c2b-7ef55327fa4f',
      name: 'DHL',
    },
    {
      id: '74671b1e-f2e1-46a2-a14c-db0229991f8c',
      name: 'PPL',
    },
    {
      id: 'a6df6711-a95f-4437-bb55-eb3aa789d199',
      name: 'UPS',
    },
  ],
};

export const mockGetAllegroShippingRate: AllegroShippingRateDetail = {
  id: 'a941cfdc-f4f7-4557-8c2b-7ef55327fa4f',
  name: 'DHL',
  rates: [{
    deliveryMethod: {
      id: '4bd8a63a-5464-4988-bd34-b7e41d25fbb0',
    },
  },
  {
    deliveryMethod: {
      id: '59dc3285-d9ee-4edc-baed-4183c1c3bc31',
    },
  },
  {
    deliveryMethod: {
      id: 'ceedaec0-cfca-4cb4-8c3a-2045b42c2972',
    },
  }],
  lastModified: '2018-04-05T12:20:23.974Z',
};

export const mockGetAllegroDeliveryMethods: AllegroDeliveryMethods = {
  deliveryMethods: [
    {
      id: '4bd8a63a-5464-4988-bd34-b7e41d25fbb0',
      name: 'DHL PARCEL',
      marketplaces: ['allegro-pl', 'allegro-cz'],
    },
    {
      id: '59dc3285-d9ee-4edc-baed-4183c1c3bc31',
      name: 'DHL HOME',
      marketplaces: ['allegro-pl', 'allegro-cz'],
    },
    {
      id: 'ceedaec0-cfca-4cb4-8c3a-2045b42c2972',
      name: 'DHL BOX',
      marketplaces: ['allegro-pl', 'allegro-cz'],
    },
    {
      id: 'cc9adeaa-66e6-4090-bc8b-981203c73641',
      name: 'UPS PARCEL',
      marketplaces: ['allegro-pl', 'allegro-cz'],
    },
    {
      id: 'cb249e87-5a74-45d5-8d8a-0af6a51a97f8',
      name: 'UPS HOME',
      marketplaces: ['allegro-pl', 'allegro-cz'],
    },
  ],
};

export const mockGetAllegroOrderCarriers: AllegroOrderCarriers = {
  carriers: [
    {
      id: 'POCZTA_POLSKA',
      name: 'Poczta Polska',
    },
    {
      id: 'DHL',
      name: 'DHL',
    },
    {
      id: 'YUN_EXPRESS',
      name: 'Yun Express',
    },
    {
      id: 'OTHER',
    },
  ],
};

export const mockGetAllegroDeliveryServices: AllegroDeliveryServices = {
  services: [
    {
      id: {
        deliveryMethodId: '12d2c05d-5807-4fbe-8471-1ad29a637bdc',
        credentialsId: null,
      },
      name: 'Allegro Express One Courier payment on delivery',
      owner: 'ALLEGRO',
    },
    {
      id: {
        deliveryMethodId: '02d2c05d-e7f3-494f-a597-1ad29a637bdc',
        credentialsId: null,
      },
      name: 'Allegro Express One Courier',
      owner: 'ALLEGRO',
    },
    {
      id: {
        deliveryMethodId: '5d9c7838-e05f-4dec-afdd-58e884170ba7',
        credentialsId: 'ce114ac7-5b44-4066-bd29-92caefd0c871',
      },
      name: 'Allegro Kurier24 InPost (InPost SHIPX)',
      owner: 'CLIENT',
    },
  ],
};
